
import { v4 as uuidv4 } from 'uuid';

import _ from "lodash";

export function findEntityIndicesById(arr, entityId, entity, listIndex, sectionIndex, itemIndex) {
	if (_.isUndefined(listIndex)) {
		listIndex = -1;
	}
	if (_.isUndefined(sectionIndex)) {
		sectionIndex = -1;
	}
	if (_.isUndefined(itemIndex)) {
		itemIndex = -1;
	}

	for (var i = 0; i < arr.length; i++) {
		if (arr[i].entity.type === "list") {
			listIndex = i;
		} else if (arr[i].entity.type === "section") {
			sectionIndex = i;
		} else if (arr[i].entity.type.startsWith("item")) {
			itemIndex = i;
		}

		if (entityId === arr[i].entity.entityId) {
			entity.found = true;
			entity.result = { type: itemIndex > -1 ? "item" : sectionIndex > -1 ? "section" : "list", listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex };
		}

		if (arr[i].hasOwnProperty("children")) {
			findEntityIndicesById(arr[i].children, entityId, entity, listIndex, sectionIndex, itemIndex);
		}
	}
}

export function findEntityChildrenById(arr, entityId, entity) {
	for (var i = 0; i < arr.length; i++) {
		if (entityId === arr[i].entity.entityId) {
			entity.found = true;
			entity.result = arr[i].children;
		}
		if (arr[i].hasOwnProperty("children")) {
			findEntityChildrenById(arr[i].children, entityId, entity);
		}
	}
}

export function addCategoryNode(entity, expanded) {
	return {
		"id": uuidv4(),
		"entity": entity,
		"expanded": expanded,
		"children": []
	};
}

export function addItemNode(entity, includeChildren = false) {
	const node = {
		"id": uuidv4(),
		"entity": entity
	};
	if (includeChildren) {
		node.expanded = true;
		node.children = [];
	}
	return node;
}

export function addCategoryEntity(entityId, label, visible) {
	return {
		"guid": uuidv4(),
		"entityId": entityId,
		"id": "",
		"type": "category",
		"lang": "",
		"label": label,
		"excludeFromNavigation": false,
		"relatedItemRefs": "",
		"labelAlexaPlain": "",
		"labelAlexaRich": "",
		"labelAudio": "",
		"labelSsml": "",
		"labelPrint": "",
		"labelAudioFile": "",
		"ignoreCompletion": false,
		"hideStatus": false,
		"breadcrumbBarVisible": true,
		"breadcrumbSearchBarVisibleAlways": false,
		"visible": visible,
		"trackData": false,
		"trackLocation": false,
		"procedureViewType": "default",
		"validationMode": "legacy",
		"itemValueCommitMode": "tapAwayIsOk",
		"autoScrollOnAdvance": true,
		"advanceOnAcknowledgeStrategy": "nextIncompleteItem",
		"showRequiredAsterisk": true,
		"requiredIndicatorSymbol": "*",
				"requiredIndicatorColor": "#b07b00",
				"itemButtonOkLabel": "OK ✓",
				"itemButtonBackLabel": "Back ↑",
				"itemButtonOkVocabAlternates": "",
				"itemButtonBackVocabAlternates": "",
				"itemButtonOkVisibility": "visible",
				"itemButtonBackVisibility": "hidden",
			"itemButtonOkPendingBehavior": "disabled",
			"fullscreenActionVariant": "standard",
			"fullscreenActionPlacement": "overlay",
			"fullscreenActionFlowWhenScrollable": false,
			"fullscreenSwipeNavigation": "enabled",
			"fullscreenSwipeSound": "auto",
			"fullscreenLabelHideControl": "auto",
			"fullscreenActionNavAlignment": "left",
			"fullscreenActionNavOrder": "primary-first",
			"fullscreenActionStyle": "emphasized",
			"fullscreenActionPrimaryColor": "#2f6df6",
			"fullscreenActionSurfaceColor": "rgba(31,35,47,0.88)",
			"fullscreenActionToolBackgroundColor": "",
			"fullscreenActionToolForegroundColor": "",
		"mediaFullscreenControlVisibility": "visible",
		"mediaResizeToggleVisibility": "hidden",
		"mediaReplayControlVisibility": "visible",
		"itemHeight": "default",
		"videoMute": true,
		"videoLoop": true,
		"videoAspectRatio": "",
		"videoFitAvailableSpace": false,
		"videoMaximumHeight": "default",
		"videoShowInBackground": false,
		"videoResizeMode": "contain",
		"videoBackgroundColor": "transparent",
		"videoOverlayColor": "transparent",
		"videoOverlayColorCustom": "rgba(255,255,255,0.7)",
		"videoInlineViewer": "native",
		"videoModalViewer": "native",
		"videoStartTime": "",
		"videoEndTime": "",
		"videoLoopSegment": false,
		"videoResumeBehavior": "restart",
		"videoCompletionBehavior": "default",
		"videoActionVisibility": "visible",
		"videoCaption": "",
		"imageAspectRatio": "16:9",
		"imageAspectRatioCustom": "",
		"imageMaximumHeight": "default",
		"imageShowInBackground": false,
		"imageFitAvailableSpace": false,
		"backgroundMediaBlurFill": false,
		"imageResizeMode": "contain",
		"imageOverlayColor": "transparent",
		"imageOverlayColorCustom": "rgba(255,255,255,0.7)",
		"imageInlineViewer": "native",
		"imageModalViewer": "native",
		"imageCropMode": "focusZoom",
		"imageFocalPoint": "center",
		"imageCropZoom": "100%",
		"imageCropRect": "0% 0% 100% 100%",
		"imageModalInitialZoom": "default",
		"imageActionVisibility": "visible",
		"imageCaption": "",
		"imageAltText": "",
		"pdfFitAvailableSpace": true,
		"itemCommentsLabel": "More Info",
		"itemRelatedItemsLabel": "Related",
		"itemAttachmentsLabel": "",
		"itemCommentsIcon": "info-circle",
		"itemRelatedItemsIcon": "chart-network",
		"itemAttachmentsIcon": "paperclip",
		"itemCommentsBackgroundColor": "",
		"itemCommentsForegroundColor": "",
		"itemRelatedItemsBackgroundColor": "",
		"itemRelatedItemsForegroundColor": "",
		"itemAttachmentsBackgroundColor": "",
		"itemAttachmentsForegroundColor": "",
		"theme": "{}",
		"stylesheet": "{}",
		"styles": "{}",
		"classes": "{}",
		"printCustomProperties": "{}",
		"filters": "{}",
		"authorProperties": "{}"
	};
}

export function addListEntity(entityId, label) {
	return {
		"guid": uuidv4(),
		"entityId": entityId,
		"id": "",
		"type": "list",
		"label": label,
		"subtitle": "",
		"excludeFromNavigation": false,
		"relatedItemRefs": "",
		"labelAlexaPlain": "",
		"labelAlexaRich": "",
		"labelAudio": "",
		"labelSsml": "",
		"labelPrint": "",
		"labelAudioFile": "",
		"defaultView": "inherit",
		"startInBirdseyeView": false,
		"color": "",
		"backgroundColor": "",
		"borderColor": "",
		"iconColor": "",
		"styles": "{}",
		"classes": "{}",
		"suppressPrint": false,
		"suppressAudio": false,
		"suppressAudioTitle": false,
		"suppressAudioEntityType": false,
		"procedureViewType": "inherit",
		"suppressAudioCompletion": false,
		"visible": true,
		"enabled": true,
				"ignoreCompletion": false,
				"itemButtonOkLabel": "",
				"itemButtonBackLabel": "",
				"itemButtonOkVocabAlternates": "",
				"itemButtonBackVocabAlternates": "",
				"itemButtonOkVisibility": "inherit",
				"itemButtonBackVisibility": "inherit",
			"itemButtonOkPendingBehavior": "inherit",
			"fullscreenActionVariant": "inherit",
			"fullscreenActionPlacement": "inherit",
			"fullscreenActionFlowWhenScrollable": "inherit",
			"fullscreenSwipeNavigation": "inherit",
			"fullscreenSwipeSound": "inherit",
			"fullscreenLabelHideControl": "inherit",
			"fullscreenActionNavAlignment": "inherit",
			"fullscreenActionNavOrder": "inherit",
			"fullscreenActionStyle": "inherit",
			"fullscreenActionPrimaryColor": "",
			"fullscreenActionSurfaceColor": "",
			"fullscreenActionToolBackgroundColor": "",
			"fullscreenActionToolForegroundColor": "",
		"mediaFullscreenControlVisibility": "inherit",
		"mediaResizeToggleVisibility": "inherit",
		"mediaReplayControlVisibility": "inherit",
		"itemHeight": "inherit",
		"videoMute": "inherit",
		"videoLoop": "inherit",
		"videoAspectRatio": "inherit",
		"videoFitAvailableSpace": "inherit",
		"videoMaximumHeight": "inherit",
		"videoShowInBackground": "inherit",
		"videoResizeMode": "inherit",
		"videoBackgroundColor": "inherit",
		"videoOverlayColor": "inherit",
		"videoOverlayColorCustom": "inherit",
		"videoInlineViewer": "inherit",
		"videoModalViewer": "inherit",
		"videoStartTime": "",
		"videoEndTime": "",
		"videoLoopSegment": "inherit",
		"videoResumeBehavior": "inherit",
		"videoCompletionBehavior": "inherit",
		"videoActionVisibility": "inherit",
		"videoCaption": "",
		"imageAspectRatio": "inherit",
		"imageAspectRatioCustom": "inherit",
		"imageMaximumHeight": "inherit",
		"imageShowInBackground": "inherit",
		"imageFitAvailableSpace": "inherit",
		"backgroundMediaBlurFill": "inherit",
		"imageResizeMode": "inherit",
		"imageOverlayColor": "inherit",
		"imageOverlayColorCustom": "inherit",
		"imageInlineViewer": "inherit",
		"imageModalViewer": "inherit",
		"imageCropMode": "inherit",
		"imageFocalPoint": "inherit",
		"imageCropZoom": "inherit",
		"imageCropRect": "inherit",
		"imageModalInitialZoom": "default",
		"imageActionVisibility": "inherit",
		"imageCaption": "",
		"imageAltText": "",
		"pdfFitAvailableSpace": "inherit",
		"itemCommentsLabel": "",
		"itemRelatedItemsLabel": "",
		"itemAttachmentsLabel": "",
		"itemCommentsIcon": "",
		"itemRelatedItemsIcon": "",
		"itemAttachmentsIcon": "",
		"itemCommentsBackgroundColor": "",
		"itemCommentsForegroundColor": "",
		"itemRelatedItemsBackgroundColor": "",
		"itemRelatedItemsForegroundColor": "",
		"itemAttachmentsBackgroundColor": "",
		"itemAttachmentsForegroundColor": "",
		"hideStatus": false,
		"groupNames": [],
		"filterTags": [],
		"showFor": "{}",
		"printProperties": {
			keepTogether: true,
			breakBefore: false,
			breakBeforeHeight: 0,
			breakAfter: false,
			breakAfterHeight: 0
		},
			"printCustomProperties": "{}",
			"repeatable": false,
			"repeatableRetainValues": false,
			"repeatableIndex": 1,
			"repeatableInitialCount": 1,
			"repeatableMaxCount": 0,
			"authorProperties": "{}"
		};
}

export function addSectionEntity(entityId, label) {
	return {
		"guid": uuidv4(),
		"entityId": entityId,
		"id": "",
		"type": "section",
		"label": label,
		"subtitle": "",
		"excludeFromNavigation": false,
		"relatedItemRefs": "",
		"labelAlexaPlain": "",
		"labelAlexaRich": "",
		"labelAudio": "",
		"labelSsml": "",
		"labelPrint": "",
		"labelAudioFile": "",
		"color": "",
		"backgroundColor": "",
		"borderColor": "",
		"iconColor": "",
		"styles": "{}",
		"classes": "{}",
		"suppressPrint": false,
		"suppressAudio": false,
		"suppressAudioTitle": false,
		"suppressAudioEntityType": false,
		"suppressAudioCompletion": false,
		"procedureViewType": "inherit",
		"visible": true,
		"enabled": true,
				"ignoreCompletion": false,
				"itemButtonOkLabel": "",
				"itemButtonBackLabel": "",
				"itemButtonOkVocabAlternates": "",
				"itemButtonBackVocabAlternates": "",
				"itemButtonOkVisibility": "inherit",
				"itemButtonBackVisibility": "inherit",
			"itemButtonOkPendingBehavior": "inherit",
			"fullscreenActionVariant": "inherit",
			"fullscreenActionPlacement": "inherit",
			"fullscreenActionFlowWhenScrollable": "inherit",
			"fullscreenSwipeNavigation": "inherit",
			"fullscreenSwipeSound": "inherit",
			"fullscreenLabelHideControl": "inherit",
			"fullscreenActionNavAlignment": "inherit",
			"fullscreenActionNavOrder": "inherit",
			"fullscreenActionStyle": "inherit",
			"fullscreenActionPrimaryColor": "",
			"fullscreenActionSurfaceColor": "",
			"fullscreenActionToolBackgroundColor": "",
			"fullscreenActionToolForegroundColor": "",
		"mediaFullscreenControlVisibility": "inherit",
		"mediaResizeToggleVisibility": "inherit",
		"mediaReplayControlVisibility": "inherit",
		"itemHeight": "inherit",
		"videoMute": "inherit",
		"videoLoop": "inherit",
		"videoAspectRatio": "inherit",
		"videoFitAvailableSpace": "inherit",
		"videoMaximumHeight": "inherit",
		"videoShowInBackground": "inherit",
		"videoResizeMode": "inherit",
		"videoBackgroundColor": "inherit",
		"videoOverlayColor": "inherit",
		"videoOverlayColorCustom": "inherit",
		"videoInlineViewer": "inherit",
		"videoModalViewer": "inherit",
		"videoStartTime": "",
		"videoEndTime": "",
		"videoLoopSegment": "inherit",
		"videoResumeBehavior": "inherit",
		"videoCompletionBehavior": "inherit",
		"videoActionVisibility": "inherit",
		"videoCaption": "",
		"imageAspectRatio": "inherit",
		"imageAspectRatioCustom": "inherit",
		"imageMaximumHeight": "inherit",
		"imageShowInBackground": "inherit",
		"imageFitAvailableSpace": "inherit",
		"backgroundMediaBlurFill": "inherit",
		"imageResizeMode": "inherit",
		"imageOverlayColor": "inherit",
		"imageOverlayColorCustom": "inherit",
		"imageInlineViewer": "inherit",
		"imageModalViewer": "inherit",
		"imageCropMode": "inherit",
		"imageFocalPoint": "inherit",
		"imageCropZoom": "inherit",
		"imageCropRect": "inherit",
		"imageModalInitialZoom": "default",
		"imageActionVisibility": "inherit",
		"imageCaption": "",
		"imageAltText": "",
		"pdfFitAvailableSpace": "inherit",
		"itemCommentsLabel": "",
		"itemRelatedItemsLabel": "",
		"itemAttachmentsLabel": "",
		"itemCommentsIcon": "",
		"itemRelatedItemsIcon": "",
		"itemAttachmentsIcon": "",
		"itemCommentsBackgroundColor": "",
		"itemCommentsForegroundColor": "",
		"itemRelatedItemsBackgroundColor": "",
		"itemRelatedItemsForegroundColor": "",
		"itemAttachmentsBackgroundColor": "",
		"itemAttachmentsForegroundColor": "",
		"hideStatus": false,
		"groupNames": [],
		"filterTags": [],
		"showFor": "{}",
		"drivesFilters": "{}",
		"printProperties": {
			keepTogether: true,
			breakBefore: false,
			breakBeforeHeight: 0,
			breakAfter: false,
			breakAfterHeight: 0
		},
		"printCustomProperties": "{}",
			"repeatable": false,
			"repeatableRetainValues": false,
			"repeatableIndex": 1,
			"repeatableInitialCount": 1,
			"repeatableMaxCount": 0,
			"optionPrefixMode": "none",
			"authorProperties": "{}"
		};
}

export function addItemEntity(entityId, label, label2, labelOnly, mandatory, comments, type) {
	// Need to support types
	let item = {
		"guid": uuidv4(),
		"entityId": entityId,
		"id": "",
		"type": type ? type : "item",
		"navTitle": "",
		"excludeFromNavigation": false,
		"relatedItemRefs": "",
		"label": label,
		"label1EditorAdvanced": false,
		"label1AlexaPlain": "",
		"label1AlexaRich": "",
		"label1Audio": "",
		"label1Ssml": "",
		"label1Print": "",
		"label1AudioFile": "",
		"backgroundColor": "",
		"color": "",
		"styles": "{}",
		"classes": "{}",
		"label2": label2,
		"label2EditorAdvanced": false,
		"label2AlexaPlain": "",
		"label2AlexaRich": "",
		"label2Audio": "",
		"label2Ssml": "",
		"label2Print": "",
		"label2AudioFile": "",
		"label2Color": "",
		"labelsMaxLines": 0,
		"labelsOverlayPreset": "custom",
		"labelsCollapsedHeightMode": "percent",
		"labelsCollapsedHeightPercent": 0,
		"labelsCollapsedHeightPx": 0,
		"labelsCollapsedHeightPercentPortrait": 0,
		"labelsCollapsedHeightPercentLandscape": 0,
		"labelsCollapsedHeightPercentMobilePortrait": 0,
		"labelsCollapsedHeightPercentMobileLandscape": 0,
		"labelsCollapsedHeightPercentWebPortrait": 0,
		"labelsCollapsedHeightPercentWebLandscape": 0,
		"labelsCollapsedHeightPxPortrait": 0,
		"labelsCollapsedHeightPxLandscape": 0,
		"labelsCollapsedHeightPxMobilePortrait": 0,
		"labelsCollapsedHeightPxMobileLandscape": 0,
		"labelsCollapsedHeightPxWebPortrait": 0,
		"labelsCollapsedHeightPxWebLandscape": 0,
		"labelsOverflowMode": "expand",
		"labelsExpandBehavior": "resizeMedia",
		"labelsReserveCollapsedSpaceForMedia": false,
		"labelsHandlePosition": "top",
		"labelsMaxExpandPercent": 75,
		"labelsMinExpandPercent": 0,
		"labelOnly": labelOnly,
		"labelOnlyBackgroundColor": "",
		"linkOnCheck": false,
		"linkId": "",
		"linkActionType": "goto",
		"visible": true,
		"enabled": true,
		"required": false,
		"mandatory": mandatory,
		"valueSticky": false,
		"comments": comments,
		"commentsUrl": "",
		"commentsUrlOpenMode": "newTab",
		"commentsInline": false,
		"commentsAuthor": "",
		"commentsAudio": "",
		"commentsSsml": "",
		"commentsPrint": "",
		"commentsAudioFile": "",
		"commentsTemplate": "",
		"commentsDataPath": "",
		"backgroundImage": "",
		"video": "",
		"videoLoop": "inherit",
		"videoMute": "inherit",
		"videoAspectRatio": "inherit",
		"videoAspectRatioCustom": "",
		"videoFitAvailableSpace": "inherit",
		"videoMaximumHeight": "inherit",
		"videoMaximumHeightAnchor": "inherit",
		"videoShowInBackground": "inherit",
		"videoResizeMode": "inherit",
		"videoBackgroundColor": "inherit",
		"videoOverlayColor": "inherit",
		"videoOverlayColorCustom": "inherit",
		"videoInlineViewer": "inherit",
		"videoModalViewer": "inherit",
		"videoStartTime": "",
		"videoEndTime": "",
		"videoLoopSegment": "inherit",
		"videoResumeBehavior": "inherit",
		"videoCompletionBehavior": "inherit",
		"videoActionVisibility": "inherit",
		"videoCaption": "",
		"videoTextTracks": [],
		"image": "",
		"imageAspectRatio": "inherit",
		"imageAspectRatioCustom": "inherit",
		"imageMaximumHeight": "inherit",
		"imageMaximumHeightAnchor": "inherit",
		"imageShowInBackground": "inherit",
		"imageFitAvailableSpace": "inherit",
		"backgroundMediaBlurFill": "inherit",
		"imageResizeMode": "inherit",
		"imageOverlayColor": "inherit",
		"imageOverlayColorCustom": "inherit",
		"imageInlineViewer": "inherit",
		"imageModalViewer": "inherit",
		"imageCropMode": "inherit",
		"imageFocalPoint": "inherit",
		"imageCropZoom": "inherit",
		"imageCropRect": "inherit",
		"imageModalInitialZoom": "default",
		"imageActionVisibility": "inherit",
		"imageCaption": "",
		"imageAltText": "",
		"imageKenBurnsEffectEnabled": false,
		"imageKenBurnsEffectDuration": "default",
		"imageKenBurnsEffectStartScaleX": "default",
		"imageKenBurnsEffectStartScaleY": "default",
		"imageKenBurnsEffectEndScaleX": "default",
		"imageKenBurnsEffectEndScaleY": "default",
			"audio": "",
			"pdf": "",
			"pdfInlineViewer": "inherit",
			"pdfModalViewer": "inherit",
			"pdfFitAvailableSpace": "inherit",
			"pdfViewMode": "inherit",
			"pdfSinglePage": "inherit",
			"pdfInitialPage": "",
			"pdfInitialZoom": "default",
			"pdfPageMode": "none",
			"pdfNamedDestination": "",
			"pdfSearchText": "",
			"threeD": "",
		"suppressPrint": false,
		"suppressAudio": false,
		"suppressAudioLabel1": false,
		"suppressAudioLabel2": false,
		"speakLabel1ButDontRepeat": false,
		"speakLabel2ButDontRepeat": false,
		"suppressAudioValue": false,
		"procedureViewType": "inherit",
		"startTimer": false,
		"stopTimer": false,
		"startTracking": false,
		"stopTracking": false,
		"saveOnCheck": false,
		"saveAndExitOnCheck": false,
		"generateReportOnCheck": false,
		"generateReportOnCheckTemplate": "",
				"ignoreCompletion": false,
				"itemHeight": "inherit",
				"itemButtonOkLabel": "",
				"itemButtonBackLabel": "",
				"itemButtonOkVocabAlternates": "",
				"itemButtonBackVocabAlternates": "",
				"itemButtonOkVisibility": "inherit",
				"itemButtonBackVisibility": "inherit",
			"itemButtonOkPendingBehavior": "inherit",
			"fullscreenActionVariant": "inherit",
			"fullscreenActionPlacement": "inherit",
			"fullscreenActionFlowWhenScrollable": "inherit",
			"fullscreenSwipeNavigation": "inherit",
			"fullscreenSwipeSound": "inherit",
			"fullscreenLabelHideControl": "inherit",
			"fullscreenActionNavAlignment": "inherit",
			"fullscreenActionNavOrder": "inherit",
			"fullscreenActionStyle": "inherit",
			"fullscreenActionPrimaryColor": "",
			"fullscreenActionSurfaceColor": "",
			"fullscreenActionToolBackgroundColor": "",
			"fullscreenActionToolForegroundColor": "",
		"mediaFullscreenControlVisibility": "inherit",
		"mediaResizeToggleVisibility": "inherit",
		"mediaReplayControlVisibility": "inherit",
		"itemCommentsLabel": "",
		"itemRelatedItemsLabel": "",
		"itemAttachmentsLabel": "",
		"itemCommentsIcon": "",
		"itemRelatedItemsIcon": "",
		"itemAttachmentsIcon": "",
		"itemCommentsBackgroundColor": "",
		"itemCommentsForegroundColor": "",
		"itemRelatedItemsBackgroundColor": "",
		"itemRelatedItemsForegroundColor": "",
		"itemAttachmentsBackgroundColor": "",
		"itemAttachmentsForegroundColor": "",
		"groupNames": [],
		"filterTags": [],
		"showFor": "{}",
		"printProperties": {
			keepTogether: true,
			breakBefore: false,
			breakBeforeHeight: 0,
			breakAfter: false,
			breakAfterHeight: 0
		},
		"printCustomProperties": "{}",
		"repeatable": false,
		"repeatableRetainValues": false,
		"repeatableIndex": 1,
		"repeatableInitialCount": 1,
		"repeatableMaxCount": 0,
		"authorProperties": "{}"
	};

	if (item.type.toLowerCase() === "itemcontainer") {
		item["containerKind"] = "form";
		item["layout"] = "stack";
		item["responsive"] = {};
		item["printLayout"] = "stack";
		item["showHeader"] = true;
	}

	if (item.type.toLowerCase() === "itemyesno") {
		item["required"] = true;
		item["requiredMessage"] = "A value is required.";
		item["yesNoAdvanceOnSelect"] = true;
	} else if (item.type.toLowerCase() === "itempicker") {
		item["required"] = true;
		item["requiredMessage"] = "A value is required.";
	} else if (item.type.toLowerCase().startsWith("itemchoice")) {
		item["required"] = true;
		item["requiredMessage"] = "A value is required.";
	} else if (item.type.toLowerCase().startsWith("itemtextinput")) {
		item["required"] = true;
		item["requiredMessage"] = "A value is required.";
	} else if (item.type.toLowerCase().startsWith("itemranking")) {
		item["required"] = false;
		item["requiredMessage"] = "A value is required.";
	} else if (item.type.toLowerCase().startsWith("itembarcodeccanner")) {
		item["required"] = false;
		item["requiredMessage"] = "A value is required.";
	} else if (item.type.toLowerCase().startsWith("itemimagepicker")) {
		// No op
	} else if (item.type.toLowerCase().startsWith("itemsketchpad")) {
		// No op
	} else if (item.type.toLowerCase().startsWith("itemdate") || item.type.toLowerCase().startsWith("itemtime")) {
		// No op
	} else if (item.type.toLowerCase() === "itemweather") {
		// No op
	}

	return item;
}

export function getLabel1Color(item) {
	let label1Color = "";
	if (item.hasOwnProperty("color") && item.color !== "") {
		label1Color = item.color;
	}

	return label1Color;
}

export function getLabel2Color(item) {
	let label2Color = "";
	if (item.hasOwnProperty("label2Color") && item.label2Color !== "") {
		label2Color = item.label2Color;
	}

	return label2Color;
}

export function findEntityByGuid(authoringActivity, guid) {
	return recurseGetEntityByGuid(authoringActivity.children, guid)
}

function recurseGetEntityByGuid(arr, guid) {
	if (arr) {
		for (let i = 0; i < arr.length; i++) {
			let child = arr[i];

			//console.log(`FIND ENTITY BY GUID: ${guid} / ${child.entity.type} ${child.entity.guid}`);
			if (child.entity.guid === guid) {
				return child;
			}

			if (child.children) {
				let found = recurseGetEntityByGuid(child.children, guid);
				if (found) {
					return found;
				}
			}
		}
	}
}
